module.exports = __webpack_public_path__ + "static/img/img-yftd.252ca3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/img-yftd.png
// module id = 459
// module chunks = 2